import flat from 'array.prototype.flat'
flat.shim()
